import {AdvancedImage, lazyload, responsive, placeholder} from '@cloudinary/react';
import {fill} from '@cloudinary/url-gen/actions/resize';
import cld from '../utils/Cloudinary';

interface ImageProps {
    src: string;
    alt?: string;
    params?: any;
    classes?: string;
}

export default function Image({ src, alt, params={}, classes }: ImageProps) {
    const { 
        width='iw', 
        height='iw', 
        quality='good', 
        res="2",
        path="build.nohma/"
    } = params;

    const w = isNaN(width) ? width : width * res;
    const h = isNaN(height) ? height : height * res;

    const image = cld.image(path+src);

    image
        .resize(fill().width(w).height(h))
        .quality(`auto:${quality}`)
        .format('auto');

    return (
        <AdvancedImage 
            cldImg={image} 
            alt={alt}
            plugins={[lazyload()]}
            className={classes}
            style={{ 
                width: `${width}px`, 
                maxWidth: '100%', // Ensure the image doesn't exceed the defined width
                height: 'auto', // Let the height adjust automatically to maintain aspect ratio
            }}
        />
    );
}